// src/pages/admin/DashboardRouter.jsx
// Auto-detects mobile vs desktop AND role, and renders the right dashboard.
//   • Desktop              → full featured Dashboard (all tabs)
//   • Mobile, super_admin  → MobileAdminDashboard (quotations/bills)
//   • Mobile, others       → MobileDashboard (catalog/design management)

import { useState } from "react";
import { useDeviceType } from "../../hooks/useMobile";
import { useAuth } from "../../hooks/useAuth";
import Dashboard from "./Dashboard";
import MobileDashboard from "./MobileDashboard";
import MobileAdminDashboard from "./MobileAdminDashboard";

export default function DashboardRouter() {
  const { permissions, isSuperAdmin } = useAuth();
  const deviceType = useDeviceType();

  const isMobile = deviceType === "mobile";
  // Super admin can manage quotations/bills; catalog managers/viewers cannot.
  const canQuotations = permissions?.canManageCustomers || isSuperAdmin;

  const [forcedDesktop, setForcedDesktop] = useState(false);

  // Tablet and desktop share same UI
  if (!isMobile || forcedDesktop) {
    return (
      <Dashboard
        onSwitchToMobile={() => setForcedDesktop(false)}
      />
    );
  }

  if (canQuotations) {
    return (
      <MobileAdminDashboard
        onSwitchToDesktop={() => setForcedDesktop(true)}
      />
    );
  }

  return (
    <MobileDashboard
      onSwitchToDesktop={() => setForcedDesktop(true)}
    />
  );
}

// export default function DashboardRouter() {
//   const isMobile = useMobile();
//   const [forcedDesktop, setForcedDesktop] = useState(false);

//   // User can opt into desktop view from mobile profile screen
//   if (!isMobile || forcedDesktop) {
//     return <Dashboard onSwitchToMobile={() => setForcedDesktop(false)} />;
//   }
//   return <Dashboard onSwitchToMobile={() => setForcedDesktop(false)} />;
//   // return <MobileDashboard onSwitchToDesktop={() => setForcedDesktop(true)} />;
// }
